import React from 'react'

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  Icon,
  IconButton,
  TextField,
  Typography,
} from '@design/pt-ui'
import DI from '../../app/di'
import { ICreativeService } from '../../interfaces/services/creatives'

import Loader from '../../components/Loader'
import { Creative } from '../../interfaces/entities/creative'
import { translateWithUserLocale } from '../../utils/i18n'

interface IProps {
  activator: any
  creative: Creative
}
type ValuesType = {
  creative_uuid: string
  url: string
  expire: string
}

const GeneratePreview = (props: IProps) => {
  const [open, setOpen] = React.useState(false)
  const [values, setValues] = React.useState<ValuesType>({
    creative_uuid: '',
    url: '',
    expire: '',
  })
  const [error, setError] = React.useState('')
  const [loading, setLoading] = React.useState(false)

  const getCreativeService = () => {
    return DI.get('CreativeService') as ICreativeService
  }

  const getPreviewLink = async () => {
    setLoading(true)
    const response = await getCreativeService().getCreativePreviewlink(
      props.creative.id,
    )
    setLoading(false)

    if (response.type === 'error') {
      setError('Failed to get previewlink. Try again.')
    } else {
      setValues(response.payload)
    }
  }

  const handleOpen = () => {
    getPreviewLink()
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }
  const handleCopyLink = () => {
    if (navigator && navigator.clipboard) {
      navigator.clipboard.writeText(values.url)
    }
    handleClose()
  }

  const errorBox = () => {
    return (
      <DialogContent sx={{ paddingTop: '10px' }}>
        <Typography variant="subtitle1">{error}</Typography>
      </DialogContent>
    )
  }

  return (
    <>
      {props.activator != null ? (
        <span onClick={handleOpen}>{props.activator}</span>
      ) : null}

      <Dialog open={open} onClose={handleClose}>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '20px',
            paddingBottom: 0,
          }}>
          <Typography variant="body1">
            {translateWithUserLocale('preview.copy_previewlink')}
          </Typography>
          <IconButton onClick={handleClose} sx={{ color: 'primary.main' }}>
            <Icon>close</Icon>
          </IconButton>
        </Box>
        <Divider />
        {loading ? (
          <div style={{ width: 533, height: 171 }}>
            <Loader variant="flex" />
          </div>
        ) : error.length > 0 ? (
          errorBox()
        ) : (
          <>
            <DialogContent sx={{ paddingTop: '10px' }}>
              <Typography variant="subtitle1">
                {translateWithUserLocale('preview.previewlink_subtitle')}
                {': '}
                {new Date(values.expire).toLocaleDateString('de-DE', {
                  hour: '2-digit',
                  minute: '2-digit',
                })}
              </Typography>
              <TextField
                id="outlined-basic"
                variant="outlined"
                value={values.url}
                fullWidth
              />
            </DialogContent>
            <DialogActions sx={{ padding: '20px' }}>
              <Button onClick={handleClose} color="primary">
                {translateWithUserLocale('cancel')}
              </Button>
              <Button
                onClick={handleCopyLink}
                color="secondary"
                variant="contained"
                autoFocus>
                {translateWithUserLocale('copy_link')}
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    </>
  )
}

export default GeneratePreview
